// extracted by mini-css-extract-plugin
export default {"formWrap":"Register_formWrap__yIGfu","section":"Register_section__Z7sra"};